<div [ngSwitch]="mode">
	<app-login *ngSwitchCase="'Login'"></app-login>
	<app-main-layout *ngSwitchCase="'Portal'"></app-main-layout>
	<app-sb-public *ngSwitchCase="'SB'"></app-sb-public>
	<app-sb-disability *ngSwitchCase="'SBDisability'"></app-sb-disability>
	<app-sb-stil *ngSwitchCase="'SBSTIL'"></app-sb-stil>
</div>